import { Method } from 'axios';
import { apiCall } from '@/utility/api/apiUtils';
import { API_METHOD_PUT, API_UPDATE_TASK } from '@/constants/apiConstants';
import { generateHash } from '@/utility/auth/generateHashValue';

export interface UpdateTaskPayload {
  name: string;
  description?: string;
}

export interface UpdateTaskResponse {
  status: string;
  data?: any;
  message?: string;
}

export const updateTaskApi = async (
  taskUuid: string,
  payload: UpdateTaskPayload,
): Promise<UpdateTaskResponse> => {
  const method: Method = API_METHOD_PUT;
  const url = API_UPDATE_TASK(taskUuid);
  const data = payload;

  const jsonString = JSON.stringify(data);
  const additionalHeaders = {
    hash: generateHash(jsonString),
  };

  try {
    const response = await apiCall({
      method,
      url,
      data,
      headers: additionalHeaders,
    });
    return response;
  } catch (error) {
    console.error('Update Task API Call Error:', error);
    throw error;
  }
};
